module.exports = __webpack_public_path__ + "static/img/son5.304b6f1c.png";